export interface VoiceoverAvatar {
  id: VoiceoverAvatarId;
  name: string;
  imageSrc: string;
}

export const VOICEOVER_AVATARS = [
  {
    id: 'otter',
    name: 'Otter',
    imageSrc: '/assets/otter_head.png',
  },
  {
    id: 'tiger',
    name: 'Tiger',
    imageSrc: '/assets/tiger_head.png',
  },
  {
    id: 'jellyfish',
    name: 'Jellyfish',
    imageSrc: '/assets/jellyfish_head.png',
  },
] as const;

export type VoiceoverAvatarId = typeof VOICEOVER_AVATARS[number]['id'];

export const DEFAULT_VOICEOVER_AVATAR = VOICEOVER_AVATARS[0];
export const DEFAULT_VOICEOVER_AVATAR_ID = DEFAULT_VOICEOVER_AVATAR.id;

export const getVoiceoverAvatar = (avatarId: string): VoiceoverAvatar => {
  return VOICEOVER_AVATARS.find((avatar) => avatar.id === avatarId)
    || DEFAULT_VOICEOVER_AVATAR;
};
